import { Group, Pagination, Skeleton, Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useAlbums } from '~/api/queries'
import { AlbumGrid } from '~/components/blocks/AlbumGrid/AlbumGrid'

export const Route = createFileRoute('/_app/recently-added/')({
  component: RecentlyAddedPage,
})

function RecentlyAddedPage() {
  const [page, setPage] = useState(1)
  const limit = 30
  const { data, isLoading } = useAlbums({ sort: 'newest', limit, offset: (page - 1) * limit })

  const totalPages = data ? Math.ceil(data.total / limit) : 0

  return (
    <Stack gap="md">
      <Title order={2}>Recently Added</Title>

      {isLoading ? <Skeleton h={400} /> : data?.data ? <AlbumGrid albums={data.data} /> : null}

      {totalPages > 1 && (
        <Group justify="center">
          <Pagination value={page} onChange={setPage} total={totalPages} />
        </Group>
      )}
    </Stack>
  )
}
